<template>
  <div class="addWarehouse">
    <el-tabs type="border-card">
      <el-tab-pane :label="$t('warehouse.warehouseInfo')">
        <el-form
          label-width="100px"
          ref="warehouseDialog"
          :label-position="'right'"
          :rules="rules"
          :model="addInfo"
        >
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('warehouse.table.gmtCreateBy')" prop="gmtCreateBy">
                <el-input v-model="gmtCreateBy" class="inputWidth" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('warehouse.table.gmtCreate')" prop="gmtCreate">
                <el-date-picker
                  style="width: 100%"
                  v-model="gmtCreate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  disabled
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <!-- 是否直拨 -->
            <el-col :span="6">
              <el-form-item :label="$t('warehouse.table.isDirectDeliver')" prop="isDirectDeliver">
                <el-select class="inputWidth" filterable v-model="addInfo.isDirectDeliver">
                  <el-option :label="$t('addSupplierDelivery.option.direct')" value="1"></el-option>
                  <el-option
                    :label="$t('addSupplierDelivery.option.notDirect')"
                    value="0"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 仓库编码 -->
            <el-col :span="6">
              <el-form-item :label="$t('warehouse.table.createWarehouseCode')" prop="storageCode">
                <el-input
                  v-model="addInfo.storageCode"
                  class="inputWidth"
                  maxlength="32"
                  @change="(val) => handleChange(val, 'storageCode')"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 仓库类型 -->
            <el-col :span="6">
              <el-form-item label="仓库类型" prop="storageType">
                <el-select
                  v-model="addInfo.storageType"
                  class="inputWidth"
                  filterable
                  maxlength="32"
                >
                  <el-option
                    v-for="(item, index) in storageTypeList"
                    :value="item.value"
                    :label="item.label"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 存放品种 -->
            <el-col :span="6">
              <el-form-item label="存放品种" prop="productDesc">
                <el-input
                  v-model="addInfo.productDesc"
                  class="inputWidth"
                  maxlength="32"
                  @change="(val) => handleChange(val, 'productDesc')"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 国家-省 -->
            <el-col :span="6">
              <el-row :gutter="24">
                <el-col :span="16" style="padding-right: 0">
                  <el-form-item label="国家" prop="countryCode">
                    <el-select
                      filterable
                      v-model="addInfo.countryCode"
                      @change="changeCountry"
                      placeholder="请选择国家"
                      clearable
                    >
                      <el-option
                        v-for="(item, index) of countryList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item class="isShowLabel" prop="provinceCode">
                    <el-select
                      filterable
                      v-model="addInfo.provinceCode"
                      @change="changeProvince"
                      placeholder="请选择省"
                      clearable
                    >
                      <el-option
                        v-for="(item, index) of provinceList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <!-- 市-地区 -->
            <el-col :span="6">
              <el-row :gutter="24">
                <el-col :span="16">
                  <el-form-item label="市" style="padding-right: 0" prop="cityCode">
                    <el-select
                      filterable
                      v-model="addInfo.cityCode"
                      @change="changeCity"
                      placeholder="请选择市"
                      clearable
                    >
                      <el-option
                        v-for="(item, index) of cityList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item class="isShowLabel" prop="areaCode">
                    <el-select
                      filterable
                      v-model="addInfo.areaCode"
                      placeholder="请选择区"
                      clearable
                    >
                      <el-option
                        v-for="(item, index) of areaList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <!-- 仓库名称 -->
            <el-col :span="24">
              <el-form-item :label="$t('warehouse.table.createWarehouseName')" prop="storageName">
                <el-input
                  v-model="addInfo.storageName"
                  class="inputWidth"
                  clearable
                  @blur="checkStorage"
                  :placeholder="$t('warehouse.search.warehouseNamePlaceholder')"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 仓库地址 -->
            <el-col :span="24">
              <el-form-item
                :label="$t('warehouse.table.createWarehouseAddress')"
                prop="storageAddress"
              >
                <el-input
                  v-model="addInfo.storageAddress"
                  class="inputWidth"
                  clearable
                  :placeholder="$t('warehouse.storageAddressPlaceholder')"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 仓储公司编码 -->
            <el-col :span="6">
              <el-form-item
                :label="$t('warehouse.table.createWarehouseCompanyCode')"
                prop="storageCompanyCode"
              >
                <el-select
                  style="width: 100%"
                  clearable
                  filterable
                  remote
                  value-key="partnerCode"
                  :remote-method="remoteStorageMethod"
                  v-model="addInfo.storageCompanyCode"
                  :placeholder="$t('warehouse.storageCompanyCodePlaceholder')"
                  @change="storageCodeChange"
                  @clear="clearStorage"
                >
                  <el-option
                    v-for="item in storageCompanyList"
                    :key="item.partnerCode"
                    :label="item.partnerCode"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 仓储公司名称 -->
            <el-col :span="6">
              <el-form-item
                :label="$t('warehouse.table.createWarehouseCompanyName')"
                prop="storageCompanyName"
              >
                <el-select
                  style="width: 100%"
                  clearable
                  filterable
                  remote
                  value-key="partnerCode"
                  :remote-method="remoteStorageNameMethod"
                  v-model="addInfo.storageCompanyName"
                  :placeholder="$t('warehouse.storageCompanyNamePlaceholder')"
                  @change="storageNameChange"
                  @clear="clearStorage"
                >
                  <el-option
                    v-for="item in storageCompanyList"
                    :key="item.partnerZhName || item.partnerEnName"
                    :label="item.partnerZhName || item.partnerEnName"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 联系人 -->
            <el-col :span="6">
              <el-form-item :label="$t('warehouse.table.contractPerson')" prop="contactPerson">
                <el-input
                  v-model="addInfo.contactPerson"
                  class="inputWidth"
                  clearable
                  maxlength="32"
                  :placeholder="$t('warehouse.contractPersonPlaceholder')"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 联系电话 -->
            <el-col :span="6">
              <el-form-item
                :label="$t('warehouse.table.contractTelephone')"
                prop="contactTelephone"
              >
                <el-input
                  v-model="addInfo.contactTelephone"
                  class="inputWidth"
                  clearable
                  :placeholder="$t('warehouse.contractTelephonePlaceholder')"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 邮箱 -->
            <el-col :span="6">
              <el-form-item :label="$t('warehouse.table.email')" prop="email">
                <el-input
                  v-model="addInfo.email"
                  class="inputWidth"
                  clearable
                  :placeholder="$t('warehouse.email')"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 传真 -->
            <el-col :span="6">
              <el-form-item :label="$t('warehouse.table.faxNo')" prop="faxNo">
                <el-input
                  v-model="addInfo.faxNo"
                  class="inputWidth"
                  clearable
                  :placeholder="$t('warehouse.faxNo')"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="department-content">{{ this.$t('warehouse.belongCompany') }}</div>
        <!--新增/删除按钮-->
        <vxe-toolbar>
          <template v-slot:buttons>
            <vxe-button
              type="primary"
              icon="el-icon-plus"
              class="vxe-btn-primary"
              @click="insertEvent()"
              >{{ $t('xTable.insert') }}</vxe-button
            >
            <vxe-button
              type="primary"
              icon="el-icon-delete"
              class="vxe-btn-delete"
              @click="deleteEvent()"
              >{{ $t('xTable.delete') }}</vxe-button
            >
          </template>
        </vxe-toolbar>
        <!---可编辑表格-->
        <vxe-table
          border
          size="mini"
          show-overflow
          show-header-overflow
          ref="xTable"
          class="edit-table"
          :data="tableData"
          :edit-rules="validRules"
          :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
          @cell-click="cellClick"
        >
          <vxe-table-column type="checkbox" width="50"></vxe-table-column>
          <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
          <vxe-table-column
            field="belongCompanyNo"
            :title="$t('company.detail.companyName')"
            :edit-render="{ type: 'default' }"
          >
            <template v-slot:edit="scope">
              <el-select
                clearable
                filterable
                remote
                :remote-method="remoteMethod"
                v-model="scope.row.belongCompanyNo"
                :placeholder="$t('company.companyPlaceholder')"
                @change="$refs.xTable.updateStatus(scope)"
              >
                <el-option
                  v-for="item in companyList"
                  :disabled="item.disabled"
                  :key="item.createCompanyCode"
                  :label="item.createCompanyName"
                  :value="item.createCompanyCode"
                ></el-option>
              </el-select>
            </template>
            <template v-slot="{ row }">{{ getSelectLabel(row.belongCompanyNo) }}</template>
          </vxe-table-column>
        </vxe-table>
      </el-tab-pane>

      <el-tab-pane :label="$t('company.system')">
        <mapping-data
          ref="mappingData"
          :isEdit="true"
          :detailInfo="addInfo"
          :callLogsData="addInfo.callLogs || []"
        />
      </el-tab-pane>
    </el-tabs>

    <div class="fixed-bottom-btnList">
      <el-button type="primary" class="fixed-bottom-btn" :loading="saveLoading" @click="save()">{{
        $t('dialog.save')
      }}</el-button>
      <el-button
        type="primary"
        class="fixed-bottom-btn"
        :loading="subLoading"
        @click="addSure('2')"
        >{{ $t('dialog.submit') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/company.js';
  import { isEqual } from '@/common/js/util';
  // import searchTable from '@/components/form-item/search-table';
  import BASE_API from '@/api/dataBase';
  import mappingData from '../mappingData'; // 系统映射表
  import XEUtils from 'xe-utils';
  export default {
    name: 'addWarehouse',
    components: {
      // searchTable,
      mappingData,
    },
    data() {
      return {
        saveLoading: false,
        subLoading: false,
        storageCompanyList: [],
        gmtCreateBy: null,
        gmtCreate: null,
        addInfo: {
          storageCode: null,
          storageName: null,
          storageAddress: null,
          isDirectDeliver: null,
          storageCompanyCode: null,
          storageCompanyName: null,
          contactPerson: null,
          contactTelephone: null,
          faxNo: null,
          email: null,
          storageType: null,
          productNo: null,
          productDesc: null,
          provinceCode: null,
          countryCode: null,
          cityCode: null,
          areaCode: null,
          mdgSystemMap: {
            onedataType: '仓库编码', //中台类别
            onedataTypeValue: '', //中台类别值
            mapSystemName: 'MDG', //映射系统
            mapType: 'ZMDG_DE_CKID', //映射类别
            mapTypeValue: '', //映射类别值
          },
        },
        tableData: [],
        allCompanyList: [], //获取所有公司值
        companyList: [], //根据输入的值匹配出合适的值
        repeatFlag: false,
        storageCode: null,
        provinceList: [],
        cityList: [],
        areaList: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      storageTypeList() {
        let list = this.$baseRequest.getDictListMapByType('storage_type');
        return list;
      },
      countryList() {
        let list = this.$baseRequest.getDictListMapByType('person_national');
        return list;
      },
      rules() {
        // 校验特殊字符
        var specialValidate = (rule, value, callback) => {
          var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
          if (value != null && value.match(reg)) {
            callback(new Error(this.$t('menu.emoticons')));
          } else if (value && value.split(' ').join('').length == 0) {
            callback(new Error(this.$t('menu.blankSpace')));
          } else {
            callback();
          }
        };
        return {
          // isDirectDeliver:[
          //   {
          //     required: false,
          //     message: this.$t("warehouse.directNotEmpty"),
          //     trigger: ["blur", "change"]
          //   }
          // ],
          storageType: [
            {
              required: true,
              message: '请选择仓库类型',
              trigger: ['blur', 'change'],
            },
          ],
          productDesc: [
            {
              required: this.addInfo.storageType == '1',
              message: '请选择存放品种',
              trigger: ['blur', 'change'],
            },
          ],
          countryCode: [
            {
              required: this.addInfo.storageType == '1',
              message: '请选择国家',
              trigger: ['blur', 'change'],
            },
          ],
          provinceCode: [
            {
              required: this.addInfo.storageType == '1',
              message: '请选择省',
              trigger: ['blur', 'change'],
            },
          ],
          cityCode: [
            {
              required: this.addInfo.storageType == '1',
              message: '请选择市',
              trigger: ['blur', 'change'],
            },
          ],
          areaCode: [
            {
              required: this.addInfo.storageType == '1',
              message: '请选择地区',
              trigger: ['blur', 'change'],
            },
          ],
          storageName: [
            {
              required: true,
              message: this.$t('warehouse.storageNameNotEmpty'),
              trigger: ['blur', 'change'],
            },
            {
              min: 1,
              max: 64,
              message: this.$t('company.companyNameWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          storageAddress: [
            {
              min: 1,
              max: 128,
              message: this.$t('company.storageAddressWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
            {
              required: this.addInfo.storageType == '1',
              message: '仓库地址不能为空',
              trigger: ['blur', 'change'],
            },
          ],
          storageCompanyCode: [
            {
              required: this.addInfo.storageType == '1',
              message: this.$t('warehouse.storageCompanyCodeNotEmpty'),
              trigger: 'change',
            },
          ],
          storageCompanyName: [
            {
              required: this.addInfo.storageType == '1',
              message: this.$t('warehouse.storageCompanyNameNotEmpty'),
              trigger: 'change',
            },
          ],
          contactPerson: [
            {
              required: this.addInfo.storageType == '1',
              message: '请输入联系人',
              trigger: ['blur', 'change'],
            },
            {
              min: 1,
              max: 32,
              message: this.$t('company.contractPersonWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          contactTelephone: [
            {
              required: this.addInfo.storageType == '1',
              message: '请输入联系电话',
              trigger: ['blur', 'change'],
            },
            {
              min: 1,
              max: 32,
              message: this.$t('company.contractPersonWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
        };
      },
      validRules() {
        return {
          belongCompanyNo: [{ required: true, message: this.$t('company.companyNameNotEmpty') }],
        };
      },
    },
    mounted() {
      this.initData();
    },
    methods: {
      handleChange(val, prop) {
        if (prop == 'storageCode') {
          this.$refs.mappingData.tableData[0].onedataTypeValue = val;
        }
      },
      changeCountry(value) {
        this.addInfo.provinceCode = '';
        this.addInfo.cityCode = '';
        this.addInfo.areaCode = '';
        this.provinceList = [];
        this.cityList = [];
        this.areaList = [];
        if (!value) return;
        this.changeProvince();
        this.$axios.post(BASE_API.QUERY_PROVICE + '?parentAreaNo=' + value, {}).then((res) => {
          if (res.data.code === 0) {
            this.provinceList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },

      // 省份切换 => 获取城市
      changeProvince(value) {
        this.addInfo.cityCode = '';
        this.addInfo.areaCode = '';
        this.cityList = [];
        this.areaList = [];
        if (!value) return;
        this.changeCity();
        this.$axios.post(BASE_API.QUERY_CITY + '?parentAreaNo=' + value, {}).then((res) => {
          if (res.data.code === 0) {
            this.cityList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 城市切换 =》 获取地区
      changeCity(value) {
        this.addInfo.areaCode = '';
        this.areaList = [];
        if (!value) return;
        this.$axios.post(BASE_API.QUERY_AERA + '?parentAreaNo=' + value, {}).then((res) => {
          if (res.data.code === 0) {
            this.areaList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      initData() {
        if (this.$refs['warehouseDialog']) {
          this.$refs['warehouseDialog'].resetFields();
        }
        this.load = false;
        this.gmtCreateBy = this.userInfo.userInfo.userName;
        this.gmtCreate = new Date();
        //初始化所有公司下拉值
        this.initCompany();
        this.$refs.mappingData.initData([this.addInfo.mdgSystemMap]);
      },
      remoteStorageMethod(query) {
        this.getPartnerList(query, '1');
      },
      remoteStorageNameMethod(query) {
        this.getPartnerList(query, '2');
      },
      //获取合作伙伴-仓储列表
      getPartnerList(query, flag) {
        const params = {
          partnerTypes: 'HZHB07,HZHB02,HZHB03',
        };
        if (flag == '1') {
          params.partnerCode = query ? query : null;
        }
        if (flag == '2') {
          params.partnerName = query ? query : null;
        }
        this.$axios.post(API.GET_PARTNER_LIST_API, params).then((res) => {
          if (0 == res.data.code) {
            this.storageCompanyList = res.data.data;
            this.storageCompanyList = XEUtils.uniqObjArr(this.storageCompanyList, 'partnerCode');
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //清楚选中
      clearStorage() {
        this.storageCompanyList = [];
      },
      storageCodeChange(val) {
        this.addInfo.storageCompanyCode = val.partnerCode;
        this.addInfo.storageCompanyName = val.partnerZhName || val.partnerEnName;
      },
      storageNameChange(val) {
        this.addInfo.storageCompanyCode = val.partnerCode;
        this.addInfo.storageCompanyName = val.partnerZhName || val.partnerEnName;
      },
      //新增一行
      insertEvent() {
        if (this.$refs.xTable.getTableData().fullData.length == this.allCompanyList.length) {
          return this.$message({
            showClose: true,
            message: this.$t('warehouse.currentUsersCannotAdd'),
            type: 'error',
          });
        }
        this.$refs.xTable.validate((valid) => {
          if (valid) {
            this.companyList = [];
            const record = {
              belongCompanyNo: null,
            };
            this.$refs.xTable.insert(record).then(({ row }) => this.$refs.xTable.setActiveRow(row));
          }
          this.remoteMethod();
        });
      },
      //删除一行
      deleteEvent() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        if (selectRecords.length) {
          this.$refs.xTable.removeSelecteds();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
      },
      //根据code匹配出name
      getSelectLabel(value, valueProp = 'createCompanyCode', labelField = 'createCompanyName') {
        let item = XEUtils.find(this.allCompanyList, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      //获取所有公司下拉
      initCompany() {
        if (this.$refs.xTable.getTableData().fullData.length == 0) {
          const record = {
            belongCompanyNo: this.userInfo.userInfo.companyCode,
            createCompanyCode: this.userInfo.userInfo.companyCode,
            createCompanyName: this.userInfo.userInfo.companyName,
          };
          this.$refs.xTable.insert(record);
          this.getSelectLabel(record.belongCompanyNo);
        }
        if (this.userInfo.userInfo.adminFlag == 1) {
          const params = {
            tenantCode: this.userInfo.userInfo.tenantCode,
            adminFlag: this.userInfo.userInfo.adminFlag,
          };
          this.$axios.post(API.GET_COMPANY_LIST_API, params).then((res) => {
            if (0 == res.data.code) {
              let temporarilyAllList = [];
              temporarilyAllList = res.data.data;
              let allComponyList = this.$refs.xTable.getTableData().fullData;
              allComponyList.forEach((i) => {
                temporarilyAllList.forEach((e) => {
                  if (i.belongCompanyNo == e.createCompanyCode) {
                    e.disabled = true;
                  }
                });
              });
              this.allCompanyList = temporarilyAllList;
            } else {
              this.$alert(res.data.msg);
            }
          });
        } else {
          const params = {
            id: this.userInfo.userInfo.userCode,
            userCode: this.userInfo.userInfo.userCode,
            personName: this.userInfo.userInfo.userName,
          };
          this.$axios.post(API.GET_COMPANY_API, params).then((res) => {
            if (0 == res.data.code) {
              let temporarilyAllList = [];
              temporarilyAllList = res.data.data.personCompanyInfo;
              temporarilyAllList.map((i) => {
                (i.createCompanyName = i.personCompanyName),
                  (i.createCompanyCode = i.personCompanyCode);
              });
              let allComponyList = this.$refs.xTable.getTableData().fullData;
              allComponyList.forEach((i) => {
                temporarilyAllList.forEach((e) => {
                  if (i.belongCompanyNo == e.createCompanyCode) {
                    e.disabled = true;
                  }
                });
              });
              this.allCompanyList = temporarilyAllList;
            } else {
              this.$alert(res.data.msg);
            }
          });
        }
      },
      //获取公司下拉
      remoteMethod(query) {
        if (query != '') {
          if (this.userInfo.userInfo.adminFlag == 1) {
            const params = {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
              createCompanyName: query,
            };
            this.$axios.post(API.GET_COMPANY_LIST_API, params).then((res) => {
              if (0 == res.data.code) {
                // this.companyList = res.data.data;
                let componyChooseList = [];
                componyChooseList = res.data.data;
                let allComponyChooseList = this.$refs.xTable.getTableData().fullData;
                allComponyChooseList.forEach((i) => {
                  componyChooseList.forEach((e) => {
                    if (i.belongCompanyNo == e.createCompanyCode) {
                      e.disabled = true;
                    }
                  });
                });
                this.companyList = componyChooseList;
              } else {
                this.$alert(res.data.msg);
              }
            });
          } else {
            let obj = {
              id: this.userInfo.userInfo.userCode,
              userCode: this.userInfo.userInfo.userCode,
              personName: this.userInfo.userInfo.userName,
            };
            this.$axios.post(API.GET_COMPANY_API, obj).then((res) => {
              if (0 == res.data.code) {
                let componyChooseList = [];
                componyChooseList = res.data.data.personCompanyInfo;
                componyChooseList.map((i) => {
                  (i.createCompanyName = i.personCompanyName),
                    (i.createCompanyCode = i.personCompanyCode);
                });
                let allComponyChooseList = this.$refs.xTable.getTableData().fullData;
                allComponyChooseList.forEach((i) => {
                  componyChooseList.forEach((e) => {
                    if (i.belongCompanyNo == e.createCompanyCode) {
                      e.disabled = true;
                    }
                  });
                });
                this.companyList = componyChooseList;
              } else {
                this.$alert(res.data.msg);
              }
            });
          }
        } else {
          this.companyList = [];
        }
      },
      //
      cellClick() {
        this.companyList = this.allCompanyList;
      },
      //校验仓库名称是否重复
      checkStorage() {
        const params = {
          storageName: this.addInfo.storageName,
        };
        this.$axios.post(API.GET_CHECKSTORAGE_API, params).then((res) => {
          if (0 == res.data.code) {
            this.repeatFlag = false;
            if (res.data.data) {
              this.repeatFlag = true;
              this.storageCode = res.data.data.storageCode;
              this.$repeatAlert(
                "<div><img src='./static/img/tips.png'/>" +
                  "<div class='repeatContent'>" +
                  this.$t('confirm.repeatContent') +
                  '</div></div>',
                '',
                {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: this.$t('confirm.repeat'),
                  center: true,
                  callback: (action) => {
                    if (action == 'confirm') {
                      let path = {
                        path: '/masterData/warehouseDetail',
                        name: 'warehouseDetail',
                        meta: {
                          keepAlive: true,
                          title: '仓库详情',
                        },
                        query: {
                          storageCode: res.data.data.storageCode,
                        },
                      };
                      this.$store.dispatch('tagsView/addTabView', path).then(() => {
                        this.$nextTick(() => {
                          this.$router.push(path);
                        });
                      });
                    }
                  },
                }
              );
            }
          } else if (10000 == res.data.code) {
            this.repeatFlag = false;
            if (res.data.data) {
              this.repeatFlag = true;
              this.storageCode = res.data.data[0].storageCode;
              this.$repeatAlert(
                "<div><img src='/static/img/tips.png'/>" +
                  "<div class='repeatContent'>" +
                  this.$t('confirm.repeatContent') +
                  '</div></div>',
                '',
                {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: this.$t('confirm.repeat'),
                  center: true,
                  callback: (action) => {
                    if (action == 'confirm') {
                      let path = {
                        path: '/masterData/warehouseDetail',
                        name: 'warehouseDetail',
                        meta: {
                          keepAlive: true,
                          title: '仓库详情',
                        },
                        query: {
                          storageCode: this.storageCode,
                        },
                      };
                      this.$store.dispatch('tagsView/addTabView', path).then(() => {
                        this.$nextTick(() => {
                          this.$router.push(path);
                        });
                      });
                    }
                  },
                }
              );
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //保存
      save() {
        if (this.repeatFlag) {
          this.$repeatAlert(
            "<div><img src='/static/img/tips.png'/>" +
              "<div class='repeatContent'>" +
              this.$t('confirm.repeatContent') +
              '</div></div>',
            '',
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: this.$t('confirm.repeat'),
              center: true,
              callback: (action) => {
                if (action == 'confirm') {
                  let path = {
                    path: '/masterData/warehouseDetail',
                    name: 'warehouseDetail',
                    meta: {
                      keepAlive: true,
                      title: '仓库详情',
                    },
                    query: {
                      storageCode: this.storageCode,
                    },
                  };
                  this.$store.dispatch('tagsView/addTabView', path).then(() => {
                    this.$nextTick(() => {
                      this.$router.push(path);
                    });
                  });
                }
              },
            }
          );
          return;
        }
        this.saveLoading = true;
        let companyCodeList = [];
        let companyList = this.$refs.xTable.getTableData().fullData;
        let belongCompanyNoValid = true;
        companyList.forEach((item) => {
          if (!item.belongCompanyNo) belongCompanyNoValid = false;
          companyCodeList.push(item.belongCompanyNo);
        });
        if (!belongCompanyNoValid) {
          this.saveLoading = false;
          this.$message({
            showClose: true,
            message: '所属公司公司名称必填！',
            type: 'error',
          });
          return;
        }
        this.addInfo.tenantCode = this.userInfo.userInfo.tenantCode;
        this.addInfo.companyCode = this.userInfo.userInfo.companyCode;
        this.addInfo.companyName = this.userInfo.userInfo.companyName;
        this.addInfo.departmentCode = this.userInfo.userInfo.departmentCode;
        this.addInfo.departmentName = this.userInfo.userInfo.departmentName;
        this.addInfo.belongTenantCode = this.userInfo.userInfo.tenantCode;
        this.addInfo.currentStatus = 'ZT06';
        this.addInfo.companyCodeList = companyCodeList.length == 0 ? null : companyCodeList;
        this.addInfo.mdgSystemMap = this.$refs.mappingData.tableData[0];
        this.$axios.post(API.ADD_STORAGE_API, this.addInfo).then((res) => {
          this.saveLoading = false;
          if (0 != res.data.code) {
            this.$alert(res.data.msg);
          } else {
            // this.cancel(false);
            this.$message({
              showClose: true,
              message: res.data.msg || this.$t('message.success'),
              type: 'success',
            });

            this.dblclickEvent(res.data.data);
          }
        });
      },
      //返回详情
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/masterData/addWarehouse',
            name: 'addWarehouse',
            meta: {
              keepAlive: true,
              title: '创建仓库',
            },
          },
          toPath: {
            path: '/masterData/editWarehouse',
            name: 'editWarehouse',
            meta: {
              keepAlive: true,
              title: '仓库修改',
            },
            query: {
              storageCode: value.storageCode,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //提交
      addSure(flag) {
        console.log(flag, '---->>');
        // let xTableValidFlag = true;
        let companyCodeList = [];
        let status = false;
        if (this.repeatFlag) {
          this.$repeatAlert(
            "<div><img src='/static/img/tips.png'/>" +
              "<div class='repeatContent'>" +
              this.$t('confirm.repeatContent') +
              '</div></div>',
            '',
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: this.$t('confirm.repeat'),
              center: true,
              callback: (action) => {
                if (action == 'confirm') {
                  let path = {
                    path: '/masterData/warehouseDetail',
                    name: 'warehouseDetail',
                    meta: {
                      keepAlive: true,
                      title: '仓库详情',
                    },
                    query: {
                      storageCode: this.storageCode,
                    },
                  };
                  this.$store.dispatch('tagsView/addTabView', path).then(() => {
                    this.$nextTick(() => {
                      this.$router.push(path);
                    });
                  });
                }
              },
            }
          );
          return;
        }
        //1.校验表格
        this.$refs.xTable.validate((xTableValid) => {
          // xTableValidFlag = xTableValid;
          if (xTableValid) {
            let companyList = this.$refs.xTable.getTableData().fullData;
            companyList.forEach((item) => {
              companyCodeList.push(item.belongCompanyNo);
            });
            //2.判断是否有重复的数据
            if (companyList.length > 1) {
              let start = 1;
              for (let n = 0; n < companyList.length; n++) {
                if (status) {
                  // addSure;
                  break;
                }
                for (start; start < companyList.length; start++) {
                  if (n != start) {
                    status = isEqual(companyList[n], companyList[start], 'belongCompanyNo');
                  }
                }
                start = n;
              }
            }
            if (status) {
              this.$message({
                showClose: true,
                message: this.$t('company.companySameData'),
                type: 'error',
              });
              return;
            }
            //3.校验form表单
            this.$refs['warehouseDialog'].validate((valid) => {
              if (valid && !this.subLoading) {
                this.subLoading = true;
                this.addInfo.storageOperate = flag;
                this.addInfo.tenantCode = this.userInfo.userInfo.tenantCode;
                this.addInfo.companyCode = this.userInfo.userInfo.companyCode;
                this.addInfo.companyName = this.userInfo.userInfo.companyName;
                this.addInfo.departmentCode = this.userInfo.userInfo.departmentCode;
                this.addInfo.departmentName = this.userInfo.userInfo.departmentName;
                this.addInfo.belongTenantCode = this.userInfo.userInfo.tenantCode;
                this.addInfo.adminFlag = this.userInfo.userInfo.adminFlag;
                this.addInfo.currentStatus = flag == '1' ? 'ZT06' : 'ZT02';
                this.addInfo.companyCodeList = companyCodeList;
                this.addInfo.mdgSystemMap = this.$refs.mappingData.tableData[0];
                this.$axios.post(API.ADD_STORAGE_API, this.addInfo).then((res) => {
                  this.subLoading = false;
                  if (0 != res.data.code) {
                    this.$alert(res.data.msg);
                  } else {
                    this.cancel(false);
                    this.$message({
                      showClose: true,
                      message: res.data.msg || this.$t('message.success'),
                      type: 'success',
                    });
                  }
                });
              } else {
                return false;
              }
            });
          } else {
            this.$message({
              showClose: true,
              message: '校验不通过，请检查仓库信息是否填写正确',
              type: 'error',
            });
          }
        });
      },
      cancel(keepAlive) {
        let path = {
          fromPath: {
            path: '/masterData/addWarehouse',
            name: 'addWarehouse',
            meta: {
              keepAlive: true,
              title: '仓库创建',
            },
          },
          toPath: {
            path: '/masterData/warehouse',
            name: 'warehouse',
            meta: {
              keepAlive: keepAlive,
              title: '仓库维护',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>
<style>
  .addWarehouse .isShowLabel .el-form-item__content {
    margin-left: 0 !important;
  }
</style>
<style lang="scss" scoped>
  .addWarehouse {
    margin-bottom: 90px;

    .el-select,
    .el-input {
      width: 100%;
    }
  }
</style>
